export default __webpack_public_path__ + "static/media/logo-mobile.73c935a0.webp";